export default __webpack_public_path__ + "static/media/EmptyBag.4dfeb538.png";